import { SaveButton } from "components/Buttons"
import ModalComponent from "components/Modals"
import { vendors as VENDORS } from "config"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  CardHeader,
  CardText,
  CardTitle,
  Col,
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  ListGroup,
  ListGroupItem,
  Row,
  UncontrolledDropdown,
} from "reactstrap"
import {
  cloneProduct,
  deleteCategory,
  deleteProduct,
  getCategories,
  getFeatureRecipients,
  getProduct,
  getProductCategory,
  getProducts,
  hideCloneProductModal,
  hideDeleteCategoryModal,
  hideDeleteProductModal,
  openCloneProductModal,
  openDeleteCategoryModal,
  openDeleteProductModal,
} from "store/actions"
import { copyButtonHandler } from "utils"

const ProductList = ({
  categories,
  products,
  handleOpenProductForm,
  deleteProduct,
  deleteProductModalIsOpen,
  openDeleteProductModal,
  hideDeleteProductModal,
  getProducts,
  loading,
  handleOpenCategoriesForm,
  getProduct,
  getFeatureRecipients,
  getProductCategory,
  isDeleteCategoryModalOpen,
  openDeleteCategoryModal,
  hideDeleteCategoryModal,
  deleteCategory,
  getCategories,
  deleteCategoryLoading,
  cloneProduct,
  cloneProductModalIsOpen,
  openCloneProductModal,
  hideCloneProductModal,
}) => {
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [collapseItemIds, setCollapseItemIds] = useState({})

  useEffect(() => {
    if (categories?.length > 0) {
      let ids = { [-1]: true }
      categories?.forEach(category => {
        ids = { ...ids, [category?.id]: true }
      })
      setCollapseItemIds(ids)
    }
  }, [categories])

  const collapseToggle = productId => {
    const currentStatus = collapseItemIds[productId]
    setCollapseItemIds({ ...collapseItemIds, [productId]: !currentStatus })
  }

  const categoriesActions = [
    {
      name: "Edit",
      onClick: item => {
        getProductCategory({ id: item?.id })
        handleOpenCategoriesForm()
      },
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: item => {
        setSelectedCategory(item)
        openDeleteCategoryModal()
      },
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  const productActions = [
    {
      name: "Edit",
      onClick: item => {
        getProduct({ id: item?.id })
        getFeatureRecipients({ feature_id: item?.id, feature_type: "product" })
        handleOpenProductForm()
      },
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Remove",
      onClick: item => {
        setSelectedProduct(item)
        openDeleteProductModal()
      },
      icon: "bx bx-trash",
      isAvailable: true,
    },
    {
      name: "Clone",
      onClick: item => {
        setSelectedProduct(item)
        openCloneProductModal(true)
      },
      icon: "bx bx-copy",
      isAvailable: true,
    },
  ]

  const copyHandler = category => {
    let url = window?.location?.origin
    const vendor_id = category?.vendor_id
    const identifier = category?.identifier

    switch (vendor_id) {
      case VENDORS.HARVARD_CLIENT_ID:
        url = url + "/harvard/"
        break
      case VENDORS.IFO_CLIENT_ID:
        url = url + "/ifo_subscription/"
        break
      default:
        url = url + "/form/"
    }

    copyButtonHandler(url + identifier)
  }
  return (
    <React.Fragment>
      <Row className="my-3 d-flex justify-content-end">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Add New Product Group"
            onClick={handleOpenCategoriesForm}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <ListGroup>
            {categories?.map(category => (
              <React.Fragment key={category?.id}>
                <ListGroupItem
                  className="mt-3"
                  style={{ background: "#F0F0F0" }}
                  onClick={() => {
                    collapseToggle(category?.id)
                  }}
                >
                  <Row>
                    <Col className="mt-1">
                      <span>{category?.name} &nbsp;</span>
                      <span
                        style={{
                          cursor: "pointer",
                          color: "#556ee6",
                          fontSize: "12px",
                        }}
                        onClick={e => {
                          e.stopPropagation()
                          copyHandler(category)
                        }}
                      >
                        Copy Link
                      </span>
                    </Col>
                    <Col xs="auto">
                      <SaveButton
                        size="sm"
                        content="Add Product"
                        onClick={() => handleOpenProductForm(category?.id)}
                      />
                    </Col>
                    <Col xs="auto">
                      <UncontrolledDropdown onClick={e => e.stopPropagation()}>
                        <DropdownToggle href="#" className="card-drop" tag="i">
                          <i
                            className="mdi mdi-dots-vertical font-size-18"
                            style={{ cursor: "pointer" }}
                          />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                          {categoriesActions.map((a, index) => (
                            <DropdownItem
                              key={index}
                              href="#"
                              onClick={e => {
                                e.preventDefault()
                                a.onClick(category)
                              }}
                            >
                              <i className={a.icon} /> {a.name}
                            </DropdownItem>
                          ))}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </Col>
                  </Row>
                </ListGroupItem>
                <Collapse isOpen={collapseItemIds[category?.id]}>
                  <Row className="mt-3">
                    {products
                      ?.filter(product => product?.category_id === category?.id)
                      ?.map((item, index) => (
                        <Col key={index} sm={6} xl={3} className="p-3">
                          <Card
                            className="shadow-sm"
                            style={{ border: "1px solid", height: "100%" }}
                          >
                            <CardHeader
                              style={{ background: "transparent" }}
                              className="pb-0"
                            >
                              <Row className="d-flex justify-content-end">
                                <Col xs="auto">
                                  <UncontrolledDropdown>
                                    <DropdownToggle
                                      href="#"
                                      className="card-drop"
                                      tag="i"
                                    >
                                      <i
                                        className="dripicons-gear font-size-14"
                                        style={{ cursor: "pointer" }}
                                      />
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu-end">
                                      {productActions.map((a, index) => (
                                        <DropdownItem
                                          key={index}
                                          href="#"
                                          onClick={e => {
                                            e.preventDefault()
                                            a.onClick(item)
                                          }}
                                        >
                                          <i className={a.icon} /> {a.name}
                                        </DropdownItem>
                                      ))}
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </Col>
                              </Row>
                            </CardHeader>
                            <CardBody>
                              <CardTitle>{item?.name}</CardTitle>
                            </CardBody>
                          </Card>
                        </Col>
                      ))}
                  </Row>
                </Collapse>
              </React.Fragment>
            ))}
          </ListGroup>
          {products?.filter(product => product?.category_id === null)?.length >
            0 && (
            <ListGroup>
              <ListGroupItem
                className="mt-3"
                style={{ background: "#F0F0F0" }}
                onClick={() => {
                  collapseToggle(-1)
                }}
              >
                <Row>
                  <Col className="mt-1">
                    <span>Products without category</span>
                  </Col>
                </Row>
              </ListGroupItem>
              <Collapse isOpen={collapseItemIds[-1]}>
                <Row className="mt-3">
                  {products
                    ?.filter(product => product?.category_id === null)
                    ?.map((item, index) => (
                      <Col sm={6} xl={3} className="p-3" key={index}>
                        <Card
                          className="shadow-sm"
                          style={{ border: "1px solid", height: "100%" }}
                        >
                          <CardHeader
                            style={{ background: "transparent" }}
                            className="pb-0"
                          >
                            <Row className="d-flex justify-content-end">
                              <Col xs="auto">
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    href="#"
                                    className="card-drop"
                                    tag="i"
                                  >
                                    <i
                                      className="dripicons-gear font-size-14"
                                      style={{ cursor: "pointer" }}
                                    />
                                  </DropdownToggle>
                                  <DropdownMenu className="dropdown-menu-end">
                                    {productActions.map((a, index) => (
                                      <DropdownItem
                                        key={index}
                                        href="#"
                                        onClick={e => {
                                          e.preventDefault()
                                          a.onClick(item)
                                        }}
                                      >
                                        <i className={a.icon} /> {a.name}
                                      </DropdownItem>
                                    ))}
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </Col>
                            </Row>
                          </CardHeader>
                          <CardBody>
                            <CardTitle>{item?.name}</CardTitle>
                          </CardBody>
                        </Card>
                      </Col>
                    ))}
                </Row>
              </Collapse>
            </ListGroup>
          )}
        </Col>
      </Row>
      <ModalComponent
        title={`Delete product - "${selectedProduct?.name}"`}
        open={deleteProductModalIsOpen}
        onClose={hideDeleteProductModal}
      >
        <Row className="mb-2">
          <Col>
            <h5>Are you sure you want to delete this product?</h5>
          </Col>
        </Row>
        <Row className="my-1 d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              color="danger"
              content="Cancel"
              onClick={hideDeleteProductModal}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Delete"
              loading={loading}
              onClick={() => {
                deleteProduct({
                  id: selectedProduct?.id,
                  callback: () => {
                    getProducts({ o: "name", od: "asc" })
                  },
                })
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        title={`Delete Category  - "${selectedCategory?.name}"`}
        open={isDeleteCategoryModalOpen}
        onClose={hideDeleteCategoryModal}
      >
        <Row className="mb-2">
          <Col>
            <h5>Are you sure you want to delete this category?</h5>
          </Col>
        </Row>
        <Row className="my-1 d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              color="danger"
              content="Cancel"
              onClick={hideDeleteCategoryModal}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Delete"
              loading={deleteCategoryLoading}
              onClick={() => {
                deleteCategory({
                  categoryId: selectedCategory.id,
                  callback: () => {
                    getCategories({
                      type: 3,
                    })
                  },
                })
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        title={`Clone Product  - "${selectedProduct?.name}"`}
        open={cloneProductModalIsOpen}
        onClose={hideCloneProductModal}
      >
        <Row className="mb-2">
          <Col>
            <h5>Are you sure you want to clone this product?</h5>
            <p>{`The cloned product will have the same details as this one, except for the name. The name will be: "${selectedProduct?.name} - cloned" `}</p>
          </Col>
        </Row>
        <Row className="my-1 d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              color="danger"
              content="Cancel"
              onClick={hideCloneProductModal}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Clone"
              loading={loading}
              onClick={() => {
                cloneProduct({
                  id: selectedProduct.id,
                  callback: () => {
                    getProducts({ o: "name", od: "asc" })
                  },
                })
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  categories: state.Categories.categories,
  products: state.ProductsAndSubscriptions.products,
  deleteProductModalIsOpen:
    state.ProductsAndSubscriptions.deleteProductModalIsOpen,
  loading: state.ProductsAndSubscriptions.loading,
  isDeleteCategoryModalOpen: state.Categories.isDeleteCategoryModalOpen,
  deleteCategoryLoading: state.Categories.loading,
  cloneProductModalIsOpen:
    state.ProductsAndSubscriptions.cloneProductModalIsOpen,
})

const mapDispatchToProps = dispatch => ({
  deleteProduct: values => dispatch(deleteProduct(values)),
  openDeleteProductModal: () => dispatch(openDeleteProductModal()),
  hideDeleteProductModal: () => dispatch(hideDeleteProductModal()),
  getProducts: values => dispatch(getProducts(values)),
  getProduct: values => dispatch(getProduct(values)),
  getFeatureRecipients: values => dispatch(getFeatureRecipients(values)),
  getProductCategory: values => dispatch(getProductCategory(values)),
  openDeleteCategoryModal: () => dispatch(openDeleteCategoryModal()),
  hideDeleteCategoryModal: () => dispatch(hideDeleteCategoryModal()),
  deleteCategory: values => dispatch(deleteCategory(values)),
  getCategories: values => dispatch(getCategories(values)),
  cloneProduct: values => dispatch(cloneProduct(values)),
  openCloneProductModal: () => dispatch(openCloneProductModal()),
  hideCloneProductModal: () => dispatch(hideCloneProductModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductList)
